export const reduceByType = ({ type = 'id', list = [] }) => {
  const result = list.reduce((pre, next) => {
    const hasId = pre.find(item => item[type] == next[type]);
    if (!hasId) {
      pre.push(next);
    }
    return pre;
  }, []);
  return result;
};
export const getMenuTree = (data) => {
  const treeData = [];
  const mapData = new Map();
  let sum = 0;
  let outputObj, pid;
  const rootData = [...data];
  for (let i = 0; i < rootData.length; i++) {
    sum++;
    pid = rootData[i].pid;
    if (mapData.has(pid)) {
      // 存在，将些信息，加入到对应id=pid的对象上的children
      if (!mapData.get(pid).children) mapData.get(pid).children = [];
      const otherObj = {
        toggleOpen: false,
        active: false,
        level: mapData.get(pid).level + 1,
        parentNode: mapData.get(pid),
        topTitle: mapData.get(pid).topTitle ? mapData.get(pid).topTitle : mapData.get(pid).title
      };
      const obj = { ...rootData[i], ...otherObj };
      mapData.get(pid).children.push(obj);
      // 通过pid在Map中查找，并将当前对象，加入到对应的childres属性
      mapData.set(rootData[i].id, obj);
      // 重点(必须也加入Map)：将当前id及对应的对象，存入Map对象中
    } else if (!mapData.has(pid) && pid == null) {
      // 这里处理pid不存在，且pid 为null的处理，pid不存在，且不为null的，程序不考虑这种情况
      // 如果不存在就证明没有是父
      const otherObj = {
        toggleOpen: false,
        active: false,
        level: 0,
        parentNode: null,
        topTitle: null
      };
      outputObj = { ...rootData[i], ...otherObj };
      // 加入到要返回的数组中
      treeData.push(outputObj);
      // 将id添加到Map中
      mapData.set(rootData[i].id, outputObj);
    } else if (sum < Math.pow(data.length, 2)) {
      // 如果都没有就放在最后面，到有了的时候再加上
      rootData.push(rootData[i]);
    }
  }
  return treeData;
};
export const getMenuTreeByRelationId = (data) => {
  const treeData = [];
  const mapData = new Map();
  const relationMapData = new Map();
  let sum = 0;
  let outputObj, pid;
  const rootData = [...data];
  for (let i = 0; i < rootData.length; i++) {
    sum++;
    pid = rootData[i].pid;
    const item = rootData[i];
    if (mapData.has(pid)) {
      // 存在，将些信息，加入到对应id=pid的对象上的children
      if (item.isGroup) {
        if (!mapData.get(pid).children) mapData.get(pid).children = [];
        const otherObj = {
          toggleOpen: false,
          active: false,
          level: mapData.get(pid).level + 1,
          parentNode: mapData.get(pid),
          topTitle: mapData.get(pid).topTitle ? mapData.get(pid).topTitle : mapData.get(pid).title
        };
        const obj = { ...rootData[i], ...otherObj };
        mapData.get(pid).children.push(obj);
        // 通过pid在Map中查找，并将当前对象，加入到对应的childres属性
        mapData.set(rootData[i].id, obj);
        if (!relationMapData.has(item.relationId) && (item.relationId || item.relationId == 0)) {
          relationMapData.set(item.relationId, obj);
        }
      } else {
        if (!relationMapData.get(item.groupRelationId).children) relationMapData.get(item.groupRelationId).children = [];
        const otherObj = {
          toggleOpen: false,
          active: false,
          level: relationMapData.get(item.groupRelationId).level + 1,
          parentNode: relationMapData.get(item.groupRelationId),
          topTitle: relationMapData.get(item.groupRelationId).topTitle ? relationMapData.get(item.groupRelationId).topTitle : relationMapData.get(item.groupRelationId).title
        };
        const obj = { ...rootData[i], ...otherObj };
        relationMapData.get(item.groupRelationId).children.push(obj);
        // 通过pid在Map中查找，并将当前对象，加入到对应的childres属性
        mapData.set(rootData[i].id, obj);
      }
      // 重点(必须也加入Map)：将当前id及对应的对象，存入Map对象中
    } else if (!mapData.has(pid) && pid == null) {
      // 这里处理pid不存在，且pid 为null的处理，pid不存在，且不为null的，程序不考虑这种情况
      // 如果不存在就证明没有是父
      const otherObj = {
        toggleOpen: false,
        active: false,
        level: 0,
        parentNode: null,
        topTitle: null
      };
      outputObj = { ...rootData[i], ...otherObj };
      // 加入到要返回的数组中
      treeData.push(outputObj);
      // 将id添加到Map中
      mapData.set(rootData[i].id, outputObj);
      if (!relationMapData.has(item.relationId) && (item.relationId || item.relationId == 0)) {
        relationMapData.set(rootData[i].relationId, outputObj);
      }
    } else if (sum < Math.pow(data.length, 2)) {
      // 如果都没有就放在最后面，到有了的时候再加上
      rootData.push(rootData[i]);
    }
  }
  return treeData;
};
export const roleUseCheckeAll = (list, checkAll, selectList) => {
  const result = [];
  let setSelectList = [...selectList];
  let deleteSelectList = [];
  let addSelectList = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    item.checked = checkAll;
    if (!item.isGroup) {
      if (checkAll) {
        // 如果是全选的时候，就把选择的id给赋值
        setSelectList = [...setSelectList, item];
        addSelectList = [...addSelectList, item];
      } else {
        // 如果是非全选，考虑到搜索的时候点击全选筛选一下
        // const ids = setSelectList.map(i => i.id);
        // setSelectList = selectList.filter(i => !ids.includes(i.id));
        deleteSelectList = [...deleteSelectList, item];
      }
    }
    let children = [];
    if (item.children && item.children.length > 0) {
      const { result: childrenResult, setSelectList: childrenSetSelectList, deleteSelectList: childrenDeleteSelectList, addSelectList: childrenAddSelectList } = roleUseCheckeAll(item.children, checkAll, setSelectList);
      children = childrenResult;
      setSelectList = setSelectList.concat(childrenSetSelectList);
      deleteSelectList = deleteSelectList.concat(childrenDeleteSelectList);
      addSelectList = addSelectList.concat(childrenAddSelectList);
    }
    item.children = children;
    result.push(item);
  }
  const reduceSelectList = setSelectList.reduce((pre, next) => {
    const hasId = pre.find(item => item.id == next.id);
    if (!hasId) {
      pre.push(next);
    }
    return pre;
  }, []);
  const reduceDeleteSelectList = deleteSelectList.reduce((pre, next) => {
    const hasId = pre.find(item => item.id == next.id);
    if (!hasId) {
      pre.push(next);
    }
    return pre;
  }, []);
  const reduceAddSelectList = addSelectList.reduce((pre, next) => {
    const hasId = pre.find(item => item.id == next.id);
    if (!hasId) {
      pre.push(next);
    }
    return pre;
  }, []);
  return { setSelectList: reduceSelectList, result, deleteSelectList: reduceDeleteSelectList, addSelectList: reduceAddSelectList };
};
export const checkAllSelect = (list) => {
  let flag = true;
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (!item.checked) {
      flag = false;
      return flag;
    }
    if (item.children && item.children.length > 0) {
      flag = checkAllSelect(item.children);
      if (!flag) return flag;
    }
  }
  return flag;
};
export const getCurrentData = (arr, id) => {
  let rootArr = [...arr];
  let returnObj = {};
  // 拿到子节点
  while (rootArr.length != 0) {
    const obj = rootArr[0];
    rootArr.shift();
    if (obj.id == id) {
      returnObj = obj;
      break;
    }
    if (obj.children && obj.children.length > 0) {
      rootArr = rootArr.concat(obj.children);
    }
  };
  return returnObj;
};
export const setRoleSelectIds = (sourceList, selectIds = []) => {
  const result = [];
  for (let i = 0; i < sourceList.length; i++) {
    const item = sourceList[i];
    if (selectIds.includes(item.id)) {
      item.checked = true;
    } else if (!item.isGroup) {
      item.checked = false;
    }
    let children = [];
    // 此时为false
    if (item.parentNode && item.checked && !item.isGroup) {
      const personGroup = item.parentNode.children.filter(person => !person.isGroup);
      if (personGroup.length > 0 && personGroup.every(child => selectIds.includes(child.id))) {
        item.parentNode.checked = true;
      } else if (personGroup.some(child => !selectIds.includes(child.id))) {
        item.parentNode.checked = false;
      }
    }
    if (item.children && item.children.length > 0) {
      children = setRoleSelectIds(item.children, selectIds);
      const personChildren = children.filter(i => !i.isGroup);
      if (personChildren.length > 0 && personChildren.every(child => selectIds.includes(child.id))) {
        item.checked = true;
      } else if (personChildren.some(child => !selectIds.includes(child.id))) {
        item.checked = false;
      }
    }
    item.children = children;
    result.push(item);
  }
  return result;
};
export const personGetTreeList = (list, keyWords) => {
  const result = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    item.expand = true;
    // 如果是 group
    if (item.isGroup) {
      let children = [];
      if (item.title.indexOf(keyWords) > -1) {
        result.push(item);
      } else {
        children = personGetTreeList(item.children || [], keyWords);
        if (children && children.length > 0) {
          item.children = children;
          result.push(item);
        }
      }
      const checked = children.every(child => child.checked);
      item.checked = checked;
    } else {
      // 如果不是 group
      if (item.title.indexOf(keyWords) > -1) {
        result.push(item);
      }
    }
  }
  return result;
};
export const setItemChecked = (treeList, ids, groupIds, idName = 'id', groupIdName = 'id') => {
  const filterData = function (data) {
    // 遍历数组
    for (let i = 0; i < data.length; i++) {
      // 判断节点title是否包含关键字 如果有，那么直接进行下一循环
      const item = data[i];
      if (ids.includes(item[idName])) {
        item.checked = true;
      } else {
        //  如果节点不是末节点
        if (item.children && item.children.length > 0) {
          // 这里进行递归，获取子节点列表
          filterData(item.children, ids);
          // 判断子节点数组的长度是否为零，为零则说明改节点下的所有子孙节点的title都不包含关键字，那么就可以删除这个节点了
        }
        // 如果没有选中，并且子节点也没有的时候，就
        if (item.isGroup && item.children && item.children.length == 0 && groupIds.includes(item[groupIdName])) {
          item.checked = true;
        }
      }
    }
    return data;
  };
  const list = filterData(treeList);
  return list;
};
export const myDebounce = (fun, delay) => {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fun.call(this);
    }, delay);
  };
};
export const departmentCheckedAll = (list, checkAll, selectList, idName = 'id') => {
  const result = [];
  let setSelectList = [...selectList],
    addSelectList = [],
    deleteSelectList = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    item.checked = checkAll;
    if (checkAll) {
      setSelectList = [...setSelectList, item];
      addSelectList = [...addSelectList, item];
    } else {
      deleteSelectList = [...deleteSelectList, item];
    }
    let children = [];
    if (item.children && item.children.length) {
      const { result: childrenResult, setSelectList: childrenSetSelectList, deleteSelectList: childrenDeleteSelectList, addSelectList: childrenAddSelectList } = departmentCheckedAll(item.children, checkAll, setSelectList, idName);
      children = childrenResult;
      setSelectList = setSelectList.concat(childrenSetSelectList);
      deleteSelectList = deleteSelectList.concat(childrenDeleteSelectList);
      addSelectList = addSelectList.concat(childrenAddSelectList);
    }
    item.children = children;
    result.push(item);
  }
  const reduceSelectList = reduceByType({ type: idName, list: [...setSelectList] });
  const reduceDeleteSelectList = reduceByType({ type: idName, list: [...deleteSelectList] });
  const reduceAddSelectList = reduceByType({ type: idName, list: [...addSelectList] });
  return { result, setSelectList: reduceSelectList, deleteSelectList: reduceDeleteSelectList, addSelectList: reduceAddSelectList };
};
export const setDepartmentSelectIds = (sourceList, selectIds = [], idName = 'id') => {
  const result = [];
  for (let i = 0; i < sourceList.length; i++) {
    const item = sourceList[i];
    if (selectIds.includes(item[idName])) {
      item.checked = true;
    } else {
      item.checked = false;
    }
    let children = [];
    // 此时为false
    if (item.children && item.children.length > 0) {
      children = setDepartmentSelectIds(item.children, selectIds, idName);
    }
    item.children = children;
    result.push(item);
  }
  return result;
};
export const departmentGetSearchList = (list, keyWords) => {
  const result = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    item.expand = true;
    // 如果是 group
    let children = [];
    if (item.title.indexOf(keyWords) > -1) {
      result.push(item);
    } else {
      children = departmentGetSearchList(item.children || [], keyWords);
      if (children && children.length > 0) {
        item.children = children;
        result.push(item);
      }
    }
  }
  return result;
};
